import { render, staticRenderFns } from "./workProjectBoard.vue?vue&type=template&id=1455aa5b&scoped=true"
import script from "./workProjectBoard.vue?vue&type=script&lang=js"
export * from "./workProjectBoard.vue?vue&type=script&lang=js"
import style0 from "./workProjectBoard.vue?vue&type=style&index=0&id=1455aa5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455aa5b",
  null
  
)

export default component.exports